import TableChartOutlined from "@mui/icons-material/TableChartOutlined";
import { headerButtonSx } from "components/shared/ElementList/Header";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

interface IViewToggle {
    /** Table view displayed: the button is black */
    active: boolean;
    onClick: () => void;
}

// Same footprint as the imports / exports menu button next to it
const menuButtonSx = headerButtonSx(true);
const activeSx = {
    ...menuButtonSx,
    "&.MuiButton-root": {
        ...menuButtonSx["&.MuiButton-root"],
        backgroundColor: "#303030",
        border: "1px solid #303030 !important",
        color: "white",
        "&:hover": { backgroundColor: "#464646" },
    },
};

/** List / documents table switch, same place in both views (left of the imports / exports menu). */
const ViewToggle = ({ active, onClick }: IViewToggle) => {
    const [t] = useTranslation();

    return (
        <StyledButton
            buttonType={active ? "primary" : "outlined"}
            onClick={onClick}
            allowViewOnly
            aria-pressed={active}
            tooltipText={t(active ? "BeneficiaryDocuments.Table.ListView" : "BeneficiaryDocuments.Table.TableView")}
            sx={active ? activeSx : menuButtonSx}
        >
            <TableChartOutlined sx={{ width: 18, height: 18 }} />
        </StyledButton>
    );
};

export default ViewToggle;
